export type BoxAnimateIn =
  | 'none'
  | 'fadeIn'
  | 'fadeUp'
  | 'fadeDown'
  | 'fadeLeft'
  | 'fadeRight'
  | 'blurIn'
  | 'scaleUp'
  | 'scaleDown'

export const DEFAULT_BOX_ANIMATE_TYPE = 'none'
export const DEFAULT_BOX_ANIMATE_DELAY = 0.0
export const DEFAULT_BOX_ANIMATE_DURATION = 0.75
export const DEFAULT_ITEM_ANIMATE_TYPE = 'none'
export const DEFAULT_ITEM_ANIMATE_DELAY = 0.0
export const DEFAULT_ITEM_ANIMATE_DURATION = 0.75
export const DEFAULT_ITEM_STAGGER_DURATION = 0.0
